"use client";

import { AccentCheck } from "@health/ui";
import { useJourney } from "../journey";

type Props = {
  sectionLabel: string;
  summary?: string;
};

export function SectionCompleteCard({ sectionLabel, summary }: Props) {
  const journey = useJourney();

  return (
    <button
      type="button"
      onClick={() => journey?.openPanel()}
      className="flex items-center gap-2 text-sm pt-3 pb-1 w-full min-h-11 text-left group animate-fade-in transition-opacity duration-300"
      aria-label={`${sectionLabel} complete. ${summary ?? ""} View your journey.`}
    >
      <AccentCheck />
      <div className="flex flex-col gap-0.5 flex-1 min-w-0">
        <span className="font-medium text-text-primary">{sectionLabel} complete</span>
        {summary && <span className="text-xs text-text-secondary truncate">{summary}</span>}
      </div>
      <span className="text-text-secondary group-hover:text-accent transition-colors shrink-0">
        →
      </span>
    </button>
  );
}
